// extracted by mini-css-extract-plugin
module.exports = {"visualFilter":"visual-filter_visualFilter__Kicys"};